import React from 'react';
import CustomerContactInfoComp from './CustomerContactInfoComp';

const CustomerContactInfoPhone = props => (
<CustomerContactInfoComp
  {...props}
  autoComplete="tel"
  errorMessages={{
    'field_is_required': 'The phone field is required',
    'field_is_invalid': 'Your phone number is invalid',
  }}
  inputName="phoneNumber"
  label="Phone Number"
  description="So we can contact you if there are any updates about your holiday."
  name="phoneNumber"
  type="number"
  order={props.order}
/>
);

export default CustomerContactInfoPhone;
